






import { Component, Vue, Prop } from 'vue-property-decorator';
@Component({
    metaInfo() {
        return { title: 'コンバージョン一覧' }
    }
})
export default class ConversionDashboard extends Vue {
}
